module.exports = __webpack_public_path__ + "img/orderFail2x.png?50c9472d561bdeabc65b0208de9618ba";